angular.module('nv.components.sorter-col-input-details').component('nvSorterColInputDetails', {
  template: require('./sorter-col-input-details.html'),
  bindings: {
    // isolates scope
    disabled: '<',
    inputType: '@', // required - 'text', 'checkbox', 'dropdown', or 'autocomplete'
    items: '<', // for dropdown or autocomplete
    label: '@?',
    ngModel: '=', // required
    placeholder: '@',
    onChange: '&?', // fn to trigger on input
  },
  controller: 'SorterColInputDetailsCtrl', // controllerAs value is now $ctrl
});
